type ClassValue = string | false | null | undefined;

/**
 * Conditional class names without a ternary.
 *
 * The repo's ast-grep rules forbid ternary expressions in .tsx, so `cond ? 'a' : 'b'` is not
 * available. Logical AND is not a ternary node, so `classNames('input', invalid && 'input-error')`
 * is the sanctioned shape. See ADR 0005.
 */
export function classNames(...values: ClassValue[]): string {
  return values.filter((value): value is string => Boolean(value)).join(' ');
}
